/**
 * 上传图片的场景化大小限制。
 * 改动需同步后端 ai-game-backend-go/internal/api/oss.go 的 UploadSizeLimits
 */

/** 各场景图片大小上限（字节），key 为上传时传给后端的 file_type */
export const UPLOAD_SIZE_LIMITS: Record<string, number> = {
  portrait: 800 * 1024, // 立绘 800KB
  costume: 800 * 1024, // 衣橱 800KB
  shop_item: 200 * 1024 // 商城 200KB
}

/** 场景中文名，用于拼错误文案 */
export const UPLOAD_SCENE_NAMES: Record<string, string> = {
  portrait: '立绘',
  costume: '衣橱图片',
  shop_item: '商城图片'
}

/** 把字节数格式化成便于阅读的大小：小于 1MB 用整数 KB，否则用一位小数 MB */
export function formatFileSize(bytes: number): string {
  const MB = 1024 * 1024
  if (bytes < MB) return `${Math.round(bytes / 1024)}KB`
  return `${(bytes / MB).toFixed(1)}MB`
}

/**
 * 按场景校验文件大小。
 * 通过返回 null，超限返回可直接展示给作者的文案。
 * fileType 未登记在 UPLOAD_SIZE_LIMITS 时一律放行。
 */
export function checkUploadSize(file: File, fileType: string): string | null {
  const limit = UPLOAD_SIZE_LIMITS[fileType]
  if (limit === undefined || file.size <= limit) return null
  const scene = UPLOAD_SCENE_NAMES[fileType] || '该类型图片'
  return `图片 ${file.name} 为 ${formatFileSize(file.size)}，超过${scene}上限 ${formatFileSize(limit)}，请压缩后重新上传`
}
